export default __webpack_public_path__ + "f0852a7f47580a56a851cd55ed850cf2.png";